<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
import componentAPI from "../api/components"
import firebase from "firebase/app"
import { mapGetters } from "vuex"

export default {
  // calculated props
  computed: {
    ...mapGetters({
      user: "users/getDoc",
      org: "orgs/getDoc"
    })
  },

  // update hook
  async beforeMount() {
    await this.checkRedirects()
  },

  // methods
  methods: {
    async checkRedirects() {
      console.log("checking redirects in empty")
      const currentUser = firebase.auth().currentUser
      const userFsId = this.$store.getters["auth/getUserFsId"]

      // if user is authenticated:
      // start check if redirect needed
      if (currentUser) {
        const jwt = await currentUser.getIdToken()

        // if userFsId Reltaed to user
        if (userFsId) {
          // get user
          const { user = {} } = await componentAPI.users(jwt).get(userFsId)

          // Step 2 - check if org releted.
          if (this.isRedirectToGenOrg(user)) {
            this.$router.push("/auth/gen-org")
          } else if (await this.isRedirectToFirstIntegration(user, jwt)) {
            // Step 3 - check if there is one inregration related
            this.$router.push("/auth/first-integration")
          }
          // Step 1 - check if userFsId is related
        } else if (this.isRedirectToNewUser(userFsId)) {
          this.$router.push("/auth/new-user")
        }
      }
    },

    /**
     * Determine if is Redirect To First Integration
     */
    async isRedirectToFirstIntegration(user, jwt) {
      if (this.$route.path !== "/auth/first-integration") {
        const { org = {} } = await componentAPI.orgs(jwt).get(user.orgsList[0])
        if (Object.keys(org.hubspot || {}).length) return false
        else if (((user || {}).hubspotMap || []).length) return false
        else if (((user || {}).mailingMap || []).length) return false
        else if (((user || {}).salesforceMap || []).length) return false
        else return true
      } else {
        return false
      }
    },

    /**
     * Determine if redirect to gen org
     */
    isRedirectToGenOrg(user) {
      return (
        this.$route.path !== "/auth/gen-org" &&
        !((user || {}).orgsList || []).length
      )
    },

    /**
     * Determine if redirect to new user
     */
    isRedirectToNewUser(userFsId) {
      return this.$route.path.path !== "/auth/new-user" && !userFsId
    }
  }
}
</script>
